import css from "./NoScore.css";
import React from "react";
import { getWord } from 'utils/tenant';
import PropTypes from "prop-types";

/*
 * If the end user has permissions to see success scores
 * but the student doesn't have a success score - show an informational
 * message.
 */
const NoScore = ({opModelEnabled}) => {
    return (
        <div className={css['no-score-container']}>
            <div><span className={css['no-score-header']}>{getWord('successScore')} Unavailable</span></div>
            {opModelEnabled && <div className={css['no-score-detail']}>Student is not seeking a credential included in scoring or is not enrolled in current term.</div> }
            {!opModelEnabled && <div className={css['no-score-detail']}>This student has not been scored.</div> }
        </div>
    )
}

NoScore.propTypes = {
    opModelEnabled: PropTypes.bool
};

export default NoScore;
